import analytics from 'commons/tracking/analytics';
import type { PublishingScopeKey } from 'commons/publishing/publishingScope';

// Must not throw: the click still has to take the partner to the composition.
const report = (name: string, props: Record<string, unknown>): void => {
  try {
    analytics.logEvent(name, props);
  } catch (failure) {
    console.warn(`[publishingList] could not report ${name}`, failure);
  }
};

export const trackCompositionTileDesignProductsClick = ({
  scope,
}: {
  scope: PublishingScopeKey;
}): void => report('composition_tile_design_products_click', { scope });
